import { get } from 'lodash/object';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { AuthService } from '../../services/auth.service';
import { SessionService } from '../../services/session2.service';

import { Router, NavigationEnd } from '../../../../node_modules/@angular/router';

@Component({
  selector: 'admin-banner',
  templateUrl: './admin-banner.component.html',
  styleUrls: ['./admin-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminBannerComponent implements OnInit {

  navigationSubscription; //used to force the component to reload; This happens when you switch accounts and are already on this view

  isLoggedIn: boolean = false;
  session: any = null;
  account: string = null;

  constructor(private authService: AuthService,
              private sessionService: SessionService,
              private router: Router) {

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.sessionRefresh();
      }
    });
  }

  ngOnInit() {
    this.sessionRefresh();
  }

  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we
    // don't then we will continue to run our sessionRefresh()
    // method on every navigationEnd event
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private sessionRefresh() {
    if (this.authService.isLoggedIn) {
      this.isLoggedIn = true;
      this.sessionService.getSession().subscribe((data: any) => {
        this.session = data;
        this.account = get(this.session, 'account', null);
      });
    }
    else {
      this.isLoggedIn = false;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-banner/admin-banner.component.ts